// Arquivo para verificação das variáveis de ambiente
export const debugEnvironmentVariables = () => {
  if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
    return false
  }

  if (import.meta.env.VITE_SUPABASE_URL.includes('your-project')) {
    return false
  }

  return true
}
